import React from "react";
import { Rating } from 'react-simple-star-rating';


const CustomerReviews = (props) => {
    const { productDetail, ratingForm, setRatingForm, saveRatingData, productRating } = props;
    const rating = productDetail.avgRatting;

    const handleRatingChange = (value) => {
        setRatingForm((prevState) => ({
            ...prevState,
            ratting: value || 0,
            productId: productDetail?.productId
        }));
    };

    return (
        <div className="review_wrapper_main container-screen">
            <div className="review_section">
                <h2 className="review_heading">Customer Reviews</h2>
                <div className="rate_star d-flex justify-content-center get_reviews_rating align-items-center">
                    <Rating
                        initialValue={rating}
                        readonly
                        size={22}
                        label={`Rating: ${rating}`}
                        fractions={2}
                    />
                    <div>
                        <span className="avarage_rating_count">
                            {`( ${rating ? rating.toFixed(1) : '0.0'} ratings )`}
                        </span>

                    </div>
                </div>
                <div className="row justify-content-center my-3">
                    <div className="col-xl-6 col-lg-7 col-sm-9 col-12">
                        <div className="rate_star">
                            <label className="rete_label">Rating</label><br />
                            <Rating
                                initialValue={ratingForm?.ratting || 0}
                                size={22}
                                onClick={handleRatingChange}
                                fractions={2}
                            />
                        </div>
                        <form onSubmit={saveRatingData} className="mt-3">
                            <div className="row rating_form">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="rete_label">Review</label>
                                        <textarea
                                            type="text"
                                            className="form-control"
                                            value={ratingForm?.remark}
                                            onChange={(e) => setRatingForm({ ...ratingForm, remark: e.target.value })}
                                            placeholder="Leave a remark"
                                        />
                                    </div>
                                </div>
                                <div className="review_submit_button col-12">
                                    <button type="submit" className="web_buttons">Submit Review</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="customer_reviews_wrapper_show row justify-content-center pt-5 mt-4">
                <div className="col-sm-9 col-12">
                    {productRating?.map((item, i) => (
                        <div className="review_show_wrapper">
                            <div className="review_customer_detail" key={i}>
                                <div className="d-flex justify-content-between align-items-end">
                                    <h6 className="review_customer_name mb-0">{item?.userName}</h6>
                                </div>
                                <Rating
                                    initialValue={item?.ratting > 0 ? item?.ratting : 0}
                                    readonly
                                    size={22}
                                    label={`Rating: ${item?.ratting}`}
                                    fractions={2}
                                />
                                <div className="review_customer_comment pt-2">
                                    <span>{item?.remark}</span>
                                </div>
                            </div>
                            <div>
                                <p>{new Date(item?.createdDate).toLocaleDateString('en-GB')}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CustomerReviews;